import {
  T週報全社,
  T週報部所,
} from "../../../service/budget/kadaiKentoKaigi/TKadaiKentoKaigi"

export const e項目 = {
  予算: "予算",
  実績: "実績",
  達成率: "達成率",
  運行実績: "運行実績",
} as const

export const create合計Grid行 = (
  gridRowData: T週報全社[],
  当日週番号: number | undefined,
  項目: keyof typeof e項目
): T週報全社 => {
  return {
    所属部所コード: "",
    所属部所名: 当日週番号 + "週",
    項目: 項目,
    月間金額: gridRowData
      .filter((f) => f.項目 === 項目)
      .map((m) => m.月間金額)
      .reduce((a, b) => a + b),
    第１週金額: gridRowData
      .filter((f) => f.項目 === 項目)
      .map((m) => m.第１週金額)
      .reduce((a, b) => a + b),
    第２週金額: gridRowData
      .filter((f) => f.項目 === 項目)
      .map((m) => m.第２週金額)
      .reduce((a, b) => a + b),
    第３週金額: gridRowData
      .filter((f) => f.項目 === 項目)
      .map((m) => m.第３週金額)
      .reduce((a, b) => a + b),
    第４週金額: gridRowData
      .filter((f) => f.項目 === 項目)
      .map((m) => m.第４週金額)
      .reduce((a, b) => a + b),
    第５週金額: gridRowData
      .filter((f) => f.項目 === 項目)
      .map((m) => m.第５週金額)
      .reduce((a, b) => a + b),
    第６週金額: gridRowData
      .filter((f) => f.項目 === 項目)
      .map((m) => m.第６週金額)
      .reduce((a, b) => a + b),
    報告テキスト１: "",
    報告テキスト２: "",
  }
}

export const 部所週次業績月合計行作成 = (
  基礎データ: T週報部所,
  項目: string,
  金額: number
) => ({
  // 0を仮置き（IDの性質上0はあり得ないため）
  週次業績報告ID: 0,
  週番号: 99,
  年月: 基礎データ.年月,
  日数: 30,
  所属部所名: 基礎データ.所属部所名,
  所属部所コード: 基礎データ.所属部所コード,
  項目,
  金額,
  報告テキスト１: "",
  報告テキスト２: "",
})
